import React from 'react'
import { Link } from 'react-router'
import { MenuRoot, MenuTrigger, MenuItem, MenuContent } from '@/components/ui/menu'
import { Icon } from '.'

export default function SimpleMenu ({ menuProps, contentProps, buttonProps, trigger, items }) {
  function handleClick (item) {
    item.onClick()
  }

  return (
    <MenuRoot>
      <MenuTrigger asChild>{trigger}</MenuTrigger>
      <MenuContent {...contentProps}>
        {items?.filter(i => i)?.map((item, i) => {
          if (!item) return null
          else if (!item.type || item.type === 'item') {
            return (
              <MenuItem
                value={item.value ?? i}
                key={i}
                onClick={item.onClick ? () => handleClick(item) : null}
                as={item.to ? Link : null}
                to={item.to}
              >
                {item.icon && <Icon as={item.icon} mr={2} />}
                {item.text}
              </MenuItem>
            )
          } else return item.component
        })}
      </MenuContent>
    </MenuRoot>
  )
}
